import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=5c86d054&scoped=true&"
import script from "./DialogWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=5c86d054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86d054",
  null
  
)

export default component.exports